import { render, staticRenderFns } from "./ToggleCompareLender.vue?vue&type=template&id=53846fd8&"
import script from "./ToggleCompareLender.vue?vue&type=script&lang=js&"
export * from "./ToggleCompareLender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports